import { Component, Input, OnInit } from '@angular/core';
import { PrintBatchData } from '@app/services/batches/print-batches';

@Component({
  selector: 'app-scan-batch-success',
  templateUrl: './scan-batch-success.component.html',
  styleUrls: ['./scan-batch-success.component.scss'],
  standalone: false,
})
export class ScanBatchSuccessComponent implements OnInit {
  @Input() batch: PrintBatchData;

  constructor() {}

  ngOnInit(): void {}
}
